import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-slate-300 dark:border-[rgba(142,218,182,0.20)] bg-white dark:bg-[rgba(10,38,28,0.50)] px-3 py-1 text-base text-slate-900 dark:text-[#EAF7F0] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-slate-900 dark:file:text-[#EAF7F0] placeholder:text-slate-400 dark:placeholder:text-[#93AE9F] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-teal-500 dark:focus-visible:ring-emerald-400 focus-visible:border-teal-500 dark:focus-visible:border-emerald-400 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
